export default __webpack_public_path__ + "static/media/banner-desktop.3edef284.png";